import { observable } from "mobx";
import NavListActions from "./actions";

class NavListStoreClass extends NavListActions {
  constructor(props) {
    super();
    if (props && Object.keys(props).length > 0) {
      this.navListData1 = props.navListData;
    }
  }
  @observable navListData = this.navListData1 || {};
}

// const NavListStore = new NavListStoreClass();
// export default NavListStore;
export default NavListStoreClass;



// WEBPACK FOOTER //
// ./src/stores/NavListStore/index.js